import type { NavigateFunction } from 'react-router';

import { StripeCustomer, StripePlan, StripePrice } from '@cartwhl/common/types';
import { getStripePortalSession } from '@cartwhl/common/utils/getStripePortalSession';

import { checkoutStore } from '../../../stores/global';

export interface HandlePricingPlanSelectionArgs {
  authStatus: string;
  isPaying: boolean;
  currentProductId: string | null;
  productId: string;
  customerId: string;
  price: StripePrice;
  navigate: NavigateFunction;
}

export function getCurrentSubscriptionProductId(
  customer: StripeCustomer | null | undefined,
): string | null {
  const plan = customer?.plans?.find((item: StripePlan) => item.active);
  return plan?.product ?? null;
}

export function getPricingPlanCTA(
  authStatus: string,
  isPaying: boolean,
  currentProductId: string | null,
  cardProductId: string | undefined,
  productName: string,
) {
  if (!cardProductId) {
    return 'Loading...';
  }

  if (isPaying && currentProductId === cardProductId) {
    return 'Your current plan';
  }

  if (isPaying) {
    return `Change plan - ${productName}`;
  }

  if (authStatus === 'anonymous') {
    return 'Start 7-day free trial';
  }

  return 'Start 7-day free trial';
}

export async function handlePricingPlanSelection({
  authStatus,
  isPaying,
  currentProductId,
  productId,
  customerId,
  price,
  navigate,
}: HandlePricingPlanSelectionArgs) {
  if (authStatus === 'anonymous') {
    checkoutStore.select(price);
    const checkoutParams = new URLSearchParams({
      priceID: price.id,
    });
    navigate(`/sign-up?redirectTo=/checkout?${checkoutParams.toString()}`);
    return;
  }

  if (isPaying && currentProductId && currentProductId !== productId) {
    const portalSession = await getStripePortalSession(customerId, price.id);
    if (portalSession?.data) {
      window.location.href = portalSession.data.url;
    }
    return;
  }

  if (!isPaying) {
    checkoutStore.select(price);
    await checkoutStore.startCheckout();
  }
}
